
<div class="outerLoader" *ngIf="loading && signaturePage">
  <div id="container" >
    <div class="divider" aria-hidden="true"></div>
    <p class="loading-text" aria-label="Loading">
      <span class="letter" aria-hidden="true">L</span>
      <span class="letter" aria-hidden="true">o</span>
      <span class="letter" aria-hidden="true">a</span>
      <span class="letter" aria-hidden="true">d</span>
      <span class="letter" aria-hidden="true">i</span>
      <span class="letter" aria-hidden="true">n</span>
      <span class="letter" aria-hidden="true">g</span>
    </p>
  </div>
 </div>



<div class="progress-loader" *ngIf="loading && !signaturePage" style="z-index: 999999;">
  <div class="loader" ></div>
</div>


<!-- <div class="loader" *ngIf="aiLoader" style="z-index: 999999;">
  <p>surender</p>
</div> -->

<div class="newAiLoader" *ngIf="aiLoader"style="z-index: 999999;">
  <div class="loader"></div>
  <div class="message">
    <h4>AI is running...</h4>
    <p>Please be patient while Flowtrics AI is working.</p>
  </div>
</div>

